import { useQuery } from 'react-query';

interface OrganizationFeedbackOnUserJob {
  feedback: string;
  rating: number;
}

type UseGetOrganizationFeedbackOnUserJobHandler = {
  data: OrganizationFeedbackOnUserJob;
  error: string | null;
  isLoading: boolean;
};

const useGetOrganizationFeedbackOnUserJob = (
  jobId: number,
): UseGetOrganizationFeedbackOnUserJobHandler => {
  const { isLoading, error, data } = useQuery<
    UseGetOrganizationFeedbackOnUserJobHandler,
    string,
    OrganizationFeedbackOnUserJob
  >(
    ['get-organzation-feedback-on-user', jobId],
    async () => {
      const response = await fetch(`/api/rating/${jobId}/`);
      if (response.ok) return response.json();
      throw new Error('Something went wrong');
    },
    { retry: false },
  );
  return {
    data: data ?? ({} as OrganizationFeedbackOnUserJob),
    error,
    isLoading,
  };
};

export default useGetOrganizationFeedbackOnUserJob;
